import React, { useState } from "react";
import { BiSolidLock, BiSolidMessageDetail, BiShow, BiHide } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import AuthWrapper from "../../components/AuthWrapper";
import AuthButton from "../../components/button/AuthButton";
import FormInput from "../../components/formInput/FormInput";
import { getUserById, signIn } from "../../firebase/utility";
import { setUser } from "../../store/actions/actions";
import { useHistory } from "react-router-dom";
import { sendOtp } from "../../api/verificationApi";
import { Button, Spinner } from "reactstrap";
import ProfessionalLoader from "../../components/globals/ProfessionalLoader";

const Login = () => {
  const history = useHistory()

  const [loading, setLoading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [dispatchLoading, setDispatchLoading] = useState(false);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [credientials, setCredientials] = useState({
    email: "",
    password: "",
  });
  const resetForm = () => {
    setCredientials({
      email: "",
      password: "",
    });
  };
  const handleLogin = async () => {
    if (credientials.email === "" || credientials.password === "") {
      toast.error("Please enter both fields!");
      return;
    }
    setLoading(true);
    try {
      const res = await signIn(credientials.email, credientials.password);
      if (res?.res === true) {
        setIsVerifying(true);
        let object = { uid: res?.user, email: credientials?.email }
        sendOtp(object, (response) => {
          if (response?.status) {
            history.push('/auth/verify-code', {
              ...response?.data,
              email: object?.email,
              uid: object?.uid
            });
          } else {
            toast.error(response?.message || "Failed to send verification code.");
            setIsVerifying(false);
            setLoading(false);
          }
        })

        // const response = await getUserById(res.user, "Users");
        // if (response) {
        //   if (response?.user?.profile_status === "disabled") {
        //     toast.error("You can't log in; your profile status is disabled.");
        //     setLoading(false);
        //     return;
        //   }
        //   resetForm();
        //   dispatch(setUser(response?.user));
        //   toast.success("Login successful");
        // } else {
        //   console.error("Response is null or undefined");
        //   toast.error("User data could not be fetched.");
        // }
      } else if (res?.res === false && res?.error) {
        toast.error(res?.error);
        setLoading(false);
      } else {
        toast.error("User ID is missing or has been deleted");
        setLoading(false);
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error(error?.message || "An error occurred during login. Please try again.");
      setLoading(false);
      setIsVerifying(false);
    }
  };
  return (
    <>
      {isVerifying && (
        <ProfessionalLoader
          text="Verifying Account"
          subtext="Sending secure verification code to your email..."
        />
      )}
      <AuthWrapper
        title="Welcome Back"
        description="Login to manage your inventory and orders"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
          className="d-flex flex-column gap-3"
        >
          <div>
            <label className="form-label small fw-600 text-muted mb-1">Email Address</label>
            <FormInput
              type="text"
              placeholder="admin@techmicro.com"
              className="w-100 rounded-3 border-light py-2"
              size="large"
              value={credientials?.email}
              handleChange={(e) =>
                setCredientials((prev) => ({
                  ...prev,
                  email: e.target.value,
                }))
              }
            />
          </div>

          <div>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <label className="form-label small fw-600 text-muted mb-0">Password</label>
              <Link to="/auth/reset-password" style={{ fontSize: '0.75rem' }} className="text-decoration-none text-primary fw-600">
                Forgot?
              </Link>
            </div>
            <FormInput
              type={showPassword ? "text" : "password"}
              placeholder="••••••••"
              className="w-100 rounded-3 border-light py-2"
              size="large"
              suffix={
                showPassword ? (
                  <BiHide
                    onClick={() => setShowPassword(false)}
                    style={{ cursor: "pointer" }}
                    className="text-muted"
                  />
                ) : (
                  <BiShow
                    onClick={() => setShowPassword(true)}
                    style={{ cursor: "pointer" }}
                    className="text-muted"
                  />
                )
              }
              value={credientials?.password}
              handleChange={(e) =>
                setCredientials((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
            />
          </div>

          <div className="mt-2">
            <Button
              type="submit"
              className="w-100 rounded-3 border-0 py-2 shadow-sm text-white fw-600"
              style={{
                background: "linear-gradient(90deg, #00509d, #182848)",
                fontSize: "1rem",
                height: "48px"
              }}
              disabled={loading || isVerifying}
            >
              {loading && !isVerifying ? <Spinner size="sm" /> : "Sign In to Dashboard"}
            </Button>
          </div>
        </form>
      </AuthWrapper >
    </>
  );
};

export default Login;


